import { AvailabilityState } from '../../enums/index.js';
const isOnStock = (availabilityState) => {
    return availabilityState === AvailabilityState.OnStock;
};
const isPreOrder = (availabilityState) => {
    return availabilityState === AvailabilityState.PreOrder;
};
const isOutOfStock = (availabilityState) => {
    return availabilityState === AvailabilityState.OutOfStock;
};
const isTemporaryOutOfStock = (availabilityState) => {
    return availabilityState === AvailabilityState.TemporaryOutOfStock;
};
const isAvailable = (availabilityState) => {
    return isOnStock(availabilityState) || isPreOrder(availabilityState);
};
const isNotAvailable = (availabilityState) => {
    return !isAvailable(availabilityState);
};
export const StockAvailability = {
    isOnStock,
    isPreOrder,
    isOutOfStock,
    isTemporaryOutOfStock,
    isAvailable,
    isNotAvailable,
};
//# sourceMappingURL=stockAvailability.js.map